
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adminoDxSfL1zfbtXOZhTEjupMIsD_45tLPMDhEkobqeqFztjkMeta } from "/opt/build/repo/pages/admin.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as explore4A2m30c7pzE2npK3xi3dh1Ggau6m_45TB_45JfsUxX14WrcMeta } from "/opt/build/repo/pages/explore.vue?macro=true";
import { default as gallerySQR0rhDZvXk7tJEDT6Jh5BmXh3itPRgqHadnU7fy_xUMeta } from "/opt/build/repo/pages/gallery.vue?macro=true";
import { default as library6AIYx4s55JZUB1PL3aQrjiVVvwpWjmEA1Hk7vzGUR9QMeta } from "/opt/build/repo/pages/library.vue?macro=true";
import { default as writingq8wszuJEgxAjh2xSoUXrnmsedd2F7xChpsDbMD2zJ1UMeta } from "/opt/build/repo/pages/writing.vue?macro=true";
import { default as projectsGSHJeMnScUX9KX19Sfjs5AS8vM8NeU7YbmvtJj7lpigMeta } from "/opt/build/repo/pages/projects.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    component: () => import("/opt/build/repo/pages/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "explore",
    path: "/explore",
    component: () => import("/opt/build/repo/pages/explore.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/opt/build/repo/pages/gallery.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/opt/build/repo/pages/library.vue")
  },
  {
    name: "writing",
    path: "/writing",
    component: () => import("/opt/build/repo/pages/writing.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/opt/build/repo/pages/projects.vue")
  }
]